import { Button, CurrencyInput, InputNumberFormItem, Modal, SelectFormItem } from '@jjj/components';
import React from 'react';
import { connect } from 'react-redux';
import { t } from '../../../../../../../i18n';
import { Description, ModalBodyWrapper } from './addBulkMarkupModal.style';
import actions from './actions';
import addNewPriceListActions from '../actions';
import { getCurrencyConfig } from '../../../../../../../helpers/countriesHelpers';

export const MARKUP_TYPES = {
  PERCENT: 'percent',
  CURRENCY: 'currency',
};

const AddBulkMarkupModal = ({ isVisible, closeModal, data, changeProperty, clearValue, applyBulkMarkup }) => {
  const { editForm } = data;

  const onSubmit = () => {
    applyBulkMarkup({
      markup: data.editForm.markup.value,
      value: data.editForm.value.value,
    });
    closeModal();
  };

  const getMarkupTypesSelectOptions = () =>
    Object.values(MARKUP_TYPES).map(markupType => ({
      id: markupType,
      name: t(`dash.units.unit.priceList.add_new_pricelist.add_bulk_markup_modal.markup_types.${markupType}`),
    }));

  const handlePropertyChange = (attr, value) => {
    changeProperty({ attr, value });
  };

  const markUp = data.editForm.markup.value || MARKUP_TYPES.PERCENT;
  const { currency, locale } = getCurrencyConfig();

  return (
    <Modal
      wrapClassName="custom-footer-alignment"
      title={t('dash.units.unit.priceList.add_new_pricelist.add_bulk_markup_modal.header')}
      open={isVisible}
      destroyOnHidden
      width={600}
      onCancel={closeModal}
      centered
      footer={[
        <Button key="cancel" type="secondary" className="cancel-btn" onClick={closeModal}>
          {t('dash.common.button.cancel_label')}
        </Button>,
        <Button key="next" type="primary" className="next-btn" onClick={onSubmit}>
          {t('dash.common.button.save_label')}
        </Button>,
      ]}
    >
      <ModalBodyWrapper>
        <Description>{t('dash.units.unit.priceList.add_new_pricelist.add_bulk_markup_modal.description')}</Description>

        <SelectFormItem
          labelName={t('dash.units.unit.priceList.add_new_pricelist.add_bulk_markup_modal.markup_label')}
          data-cy="unit-pricelist-add-bulk-markup-selector"
          value={editForm.markup.value || MARKUP_TYPES.PERCENT}
          defaultValue={MARKUP_TYPES.PERCENT}
          onChange={event => {
            handlePropertyChange('markup', event);
            clearValue();
          }}
          optionValues={getMarkupTypesSelectOptions()}
        />

        {markUp === MARKUP_TYPES.PERCENT && (
          <InputNumberFormItem
            labelName={t('dash.units.unit.priceList.add_new_pricelist.add_bulk_markup_modal.value_label')}
            data-cy="unit-pricelist-add-bulk-percent-value-input"
            value={editForm?.value?.value}
            onChange={value => handlePropertyChange('value', value)}
            validateStatus={editForm?.value?.error ? 'error' : ''}
            help={editForm?.value?.touched ? editForm?.value.error : ''}
            defaultValue={0}
            min={0}
            max={100}
            formatter={value => `${value}%`}
          />
        )}

        {markUp === MARKUP_TYPES.CURRENCY && (
          <CurrencyInput
            min={0}
            locale={locale}
            defaultValue={0}
            currency={currency}
            labelName={t('dash.units.unit.priceList.add_new_pricelist.add_bulk_markup_modal.value_label')}
            value={editForm?.value?.value}
            validateStatus={editForm?.value?.error ? 'error' : ''}
            help={editForm?.value?.touched ? editForm?.value.error : ''}
            onChange={value => handlePropertyChange('value', value)}
            width="100%"
            data-cy="unit-pricelist-add-bulk-currency-value-input"
          />
        )}
      </ModalBodyWrapper>
    </Modal>
  );
};

export default connect(
  state => ({ data: state.AddNewPriceListBulkMarkup }),
  dispatch => ({
    changeProperty: /* istanbul ignore next */ data => dispatch(actions.changeProperty(data)),
    closeModal: /* istanbul ignore next */ () => dispatch(actions.closeModal()),
    applyBulkMarkup: /* istanbul ignore next */ data => dispatch(addNewPriceListActions.applyBulkMarkup(data)),
    clearValue: /* istanbul ignore next */ () => dispatch(actions.clearValue()),
    clearStore: /* istanbul ignore next */ () => dispatch(actions.clearStore()),
  }),
)(AddBulkMarkupModal);
